<template>
  <div :class="['userMenu', { open }]">
    <div class="userMenu__backdrop" @click="$emit('toggle', $event)" />
    <div class="userMenu__label" @click="$emit('toggle', $event)">
      <div class="userMenu__label--image">
        <PictureCircle :src="src" />
      </div>
      <span class="userMenu__label--text">{{ userName }}</span>
      <DropIcon :class="['userMenu__label--icon', { invert: open }]" />
    </div>
    <div class="userMenu__menu">
      <div class="userMenu__menu--header">
        <div class="userMenu__name">
          <div class="userMenu__name--text textOverflow" :title="userName">
            {{ userName }}
          </div>
        </div>
        <div class="userMenu__email">
          <div class="userMenu__email--text textOverflow" :title="userEmail">
            {{ userEmail }}
          </div>
        </div>
      </div>
      <Divider />
      <div class="userMenu__menu--body">
        <div class="userMenu__list">
          <slot name="links" />
        </div>
      </div>
      <Divider />
      <div class="userMenu__menu--footer">
        <Button
          class="userMenu__logout"
          secondary
          @click="$emit('logout', $event)"
        >
          <LogoutIcon class="userMenu__logout--icon" />
          <strong> Sair </strong>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import PictureCircle from '@/components/PictureCircle';
import LogoutIcon from '@/assets/logout.svg';
import DropIcon from '@/assets/icon-drop-gray.svg';
import Button from '@/components/Button';
import Divider from '@/components/Divider';

export default {
  name: 'UserMenu',
  components: { PictureCircle, LogoutIcon, DropIcon, Button, Divider },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
    userEmail: {
      type: String,
      required: false,
      default: null,
    },
    src: {
      required: true,
      default: null,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
